import * as React from 'react'
import { connect } from 'react-redux'

import * as Yup from 'yup'
import { Form, Formik, FormikProps } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input, Label, Modal, Button, FormGroup, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import { EmployeeUpdateRequest } from 'src//lib/api/employees'
import { Employee } from 'src/lib/interfaces/Employee.interface'

import * as employeesActions from '../../../store/employees/actions'

interface FormValues {
	lastName?: string
  firstName?: string
}

interface EmployeeEditionModalProps {
  open?: boolean
	employee: Employee
	onClose: () => void
	updateEmployee: (employeeId: string, employee: EmployeeUpdateRequest, next?: (err?: any, employee?: Employee) => void) => void
}

class EmployeeEditionModal extends React.Component<EmployeeEditionModalProps> {
  state = {
    isLoading: false
	}
	
	get initialValues() {
		const { employee } = this.props

		return {
			lastName: employee.lastName,
			firstName: employee.firstName
		}
	}

  get validationSchema() {
    return Yup.object().shape({
			lastName: Yup.string().required(),
      firstName: Yup.string().required()
    })
  }

  handleSubmit(values) {
    const { employee, updateEmployee } = this.props

    this.setState({ isLoading: true }, () => {
      updateEmployee(employee.id, values, (err?: any, updatedEmployee?: Employee) => {
        if (!err) {
          this.setState({ isLoading: false }, this.props.onClose)
        }
      })
    })
  }

  render() {
    const { isLoading } = this.state
    const { open, onClose } = this.props

    return (
      <Modal isOpen={open} toggle={onClose}>
        <Formik
          initialValues={this.initialValues}
          validationSchema={this.validationSchema}
          onSubmit={values => this.handleSubmit(values)}
          render={(props: FormikProps<FormValues>) => (
            <Form>
              <ModalHeader toggle={onClose}>Edit Employee</ModalHeader>
              <ModalBody>
                  <FormGroup>
                    <Label className="font-weight-bold text-secondary">First Name</Label>
                    <Input
                      name="firstName"
                      onChange={props.handleChange}
                      value={props.values.firstName}
                    />
                  </FormGroup>

                  <FormGroup className="mt-3">
                    <Label className="font-weight-bold text-secondary">Last Name</Label>
                    <Input
                      name="lastName"
                      value={props.values.lastName}
                      onChange={props.handleChange}
                    />
                  </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="light" onClick={onClose} disabled={isLoading}>Cancel</Button>
                <Button type="submit" color="primary" disabled={isLoading || !props.isValid}>
                  {isLoading &&
                    <FontAwesomeIcon spin className="mr-2" icon={['fas', 'spinner']} />
                  }
                  Save
                </Button>
              </ModalFooter>
            </Form>
          )}
        />
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateEmployee: (employeeId: string, employee: EmployeeUpdateRequest, next?: (err?: any, employee?: Employee) => void) =>
    dispatch(employeesActions.updateEmployee(employeeId, employee, next))
})

export default connect(null, mapDispatchToProps)(EmployeeEditionModal)



// WEBPACK FOOTER //
// ./src/routes/employees/components/EmployeeEdition.modal.tsx